module.exports = __webpack_public_path__ + "static/kafe-92f7f18ce64148d74ccdae7f53a6b33e.jpg";